<!-- subscription alert message component tag is in app-shared-layouts -->

<!-- http loader -->
<ngx-ui-loader [fgsSize]="110" [fgsType]="SPINNER.threeStrings"></ngx-ui-loader>

<!-- Message service -->
<p-toast position="top-center" key="top-center" [baseZIndex]="99999"></p-toast>
<p-toast
  position="bottom-right"
  key="bottom-right"
  [style]="{ bottom: '75px' }"
  [baseZIndex]="99999"
></p-toast>

<p-toast
  position="top-center"
  key="top-center-notActiveUserLogin"
  [baseZIndex]="99999"
>
  <ng-template let-message pTemplate="message">
    <div style="text-align: center">
      <p>{{ message.summary }}</p>
    </div>
  </ng-template>
</p-toast>

<!-- Message service with spinner -->
<p-toast position="top-center" key="top-center-spinner" [baseZIndex]="99999">
  <ng-template let-message pTemplate="message">
    <div style="text-align: center">
      <p>
        <span>{{ message.summary }} </span>
        <i class="fa fa-spin fa-circle-o-notch"></i>
      </p>
    </div>
  </ng-template>
</p-toast>

<!-- Delete confirmation modal -->
<!-- <p-confirmDialog #cd header="Confirmation" icon="pi pi-exclamation-triangle">
    <p-footer>
        <button class="btn btn-white" (click)="cd.reject()">No</button>
        <button class="btn btn-danger" (click)="cd.accept()">Yes</button>
    </p-footer>
</p-confirmDialog> -->

<div
  [@routeAnimations]="
    o && o.activatedRouteData && o.activatedRouteData['animation']
  "
>
  <router-outlet #o="outlet"></router-outlet>
</div>
